(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-specification"]) return;
  try {
    
$(document).ready(function(){
  $('.modalclick').on('click', function(e){
  e.preventDefault();
      var data_id = $(this).attr('data-id');
      $("#size-guide-new-"+data_id).addClass('is-active');
      $("#size-guide-new-"+data_id).css('opacity',1);
  });
  $('.specification_close').on('click', function(e){
    e.preventDefault();
      $(".specification-mod").removeClass('is-active');
      $(".specification-mod").css('opacity',0);
  });
});

  } catch(e) { console.error(e); }
})();
})();
